import axios from 'axios';

const UNSPLASH_API_BASE = 'https://api.unsplash.com';
const UNSPLASH_ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;

export const unsplashAPI = axios.create({
  baseURL: UNSPLASH_API_BASE,
  headers: {
    Authorization: `Client-ID ${UNSPLASH_ACCESS_KEY}`,
  },
});

// Add response interceptor for error handling
unsplashAPI.interceptors.response.use(
  response => response,
  error => {
    console.error('Unsplash API Error:', {
      status: error.response?.status,
      message: error.message,
    });
    return Promise.reject(error);
  }
);

// Fetch latest images
export const fetchCuratedImages = (page = 1, perPage = 20) =>
  unsplashAPI.get('/photos', {
    params: { 
      page, 
      per_page: perPage, 
      order_by: 'latest'
    },
  });

// Search images
export const searchImages = (query, page = 1, perPage = 20) =>
  unsplashAPI.get('/search/photos', {
    params: { query, page, per_page: perPage },
  });

// Get image by ID
export const getImageById = (id) =>
  unsplashAPI.get(`/photos/${id}`);

// Get images by collection
export const getImagesByCollection = (collectionId, page = 1, perPage = 20) =>
  unsplashAPI.get(`/collections/${collectionId}/photos`, {
    params: { page, per_page: perPage },
  });

// Track download
export const trackDownload = (downloadUrl) =>
  unsplashAPI.get(downloadUrl);
